export const battles: Record<string, string> = {
  // Header
  'Trader vs Trader — who called it right?': 'Trejder protiv trejdera — ko je bio u pravu?',

  // Tabs
  'Active Battles': 'Aktivne bitke',
  'Recent Battles': 'Nedavne bitke',
  'Top Battle Winners': 'Najbolji pobednici bitki',

  // Battle card
  'Trade Battle': 'Trejd bitka',
  'RESOLVED': 'REŠENO',
  'ACTIVE': 'AKTIVNA',
  'wins this battle!': 'pobeđuje u ovoj bici!',
  'DRAW': 'NEREŠENO',
  'Draw — neither trade hit Take Profit': 'Nerešeno — nijedan trejd nije pogodio Take Profit',

  // Winners section
  'Top Battle Traders': 'Najbolji trejderi u bitkama',
  'No battle winners yet': 'Još nema pobednika bitki',
  'Post opposing trade ideas to start battles': 'Objavi suprotne trejd ideje da pokreneš bitke',
  'Battles Won': 'Dobijene bitke',

  // Empty states
  'No active battles right now': 'Trenutno nema aktivnih bitki',
  'No recent battles': 'Nema nedavnih bitki',
  'Battles are created automatically when two traders post opposing ideas on the same instrument': 'Bitke se automatski kreiraju kada dva trejdera objave suprotne ideje na istom instrumentu',
  'Post a Trade Idea': 'Objavi trejd ideju',
};
